module.exports = __webpack_public_path__ + "static/home1-slidedown-menu-5709d4a53a20163405b764d5e4e0fc23.jpg";